import { apiWithAuth } from "@/lib/axios";
import type { Skill } from "./types";

type Restaurant = {
  id: string;
  name: string;
  role: string;
  country: string | null;
  hasFinancial: boolean;
};

export const listMyRestaurantsSkill: Skill = {
  id: "listMyRestaurants",
  description:
    "Lista los restaurantes a los que el usuario tiene acceso, con su rol en cada uno. Úsala cuando necesites el restaurantId pero no se conozca, o cuando el usuario pregunte por sus restaurantes.",
  schema: {
    type: "object",
    properties: {},
  },
  async run(_args, ctx) {
    if (!ctx.accessToken) {
      return { ok: false, error: "Sesión no disponible." };
    }
    if (ctx.follow.enabled) {
      await ctx.follow.step("Listando tus restaurantes…", { durationMs: 400 });
    }
    try {
      const { data } = await apiWithAuth.get(
        "/me/analytics/overview",
        ctx.accessToken,
      );
      const restaurants: Restaurant[] = (data?.restaurants ?? []).map(
        (r: Restaurant) => ({
          id: r.id,
          name: r.name,
          role: r.role,
          country: r.country,
          hasFinancial: r.hasFinancial,
        }),
      );
      if (ctx.follow.enabled) {
        await ctx.follow.step(
          `✓ ${restaurants.length} restaurante(s) encontrado(s)`,
          { durationMs: 600, spinner: false },
        );
        ctx.follow.clear();
      }
      return {
        ok: true,
        result: { count: restaurants.length, restaurants },
        humanSummary: `Encontré ${restaurants.length} restaurante(s).`,
      };
    } catch (err) {
      return {
        ok: false,
        error: (err as Error)?.message ?? "Error consultando restaurantes.",
      };
    }
  },
};
